import GlobalVariable from '@/global/global-variable'

// 查询进场情况
const searchInoutApi = GlobalVariable.BASE_PATH + "/rest/user/inout/record/search";

// 查询进场情况
const searchInoutStatisticsApi = GlobalVariable.BASE_PATH + "/rest/user/inout/statistics/search";

// 查询进场情况
const searchUserTimeApi = GlobalVariable.BASE_PATH + "/rest/user/inout/statistics/searchUserTime";

// 查询 总工时
const searchTotalTimeApi = GlobalVariable.BASE_PATH + "/rest/user/inout/statistics/searchTotalTime";

// 查询进场人
const getUserApi = GlobalVariable.BASE_PATH + "/rest/user/inout/record/getUser";

// 导出考勤记录
const exportInoutStatisticsApi = GlobalVariable.BASE_PATH + "/rest/user/inout/statistics/export";

export default {
    // 查询进出记录
    searchInoutApi,
    getUserApi,
    searchInoutStatisticsApi,
    searchUserTimeApi,
    searchTotalTimeApi,
    exportInoutStatisticsApi
}



// WEBPACK FOOTER //
// ./src/request/api-approach.js